<template>
  <b-modal
    :hide-footer="true"
    centered
    id="motivo-reagendamento-edit-modal"
    @hidden="$bvModal.hide('motivo-reagendamento-edit-modal')"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Motivo de Reagendamento
      </strong>
    </template>
    <form @submit.prevent="atualizarMotivoReagendamento(item)">
      <section class="row">
        <form-input
          :required="true"
          v-model="item.nome"
          label="Nome"
          grid="12"
        />
        <form-input
          v-model="item.descricao"
          label="Descrição"
          grid="12"
        />
      </section>
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-submit-edit-motivo-reagendamento btn-success mr-0"
          data-style="zoom-in"
          type="submit"
        >
          {{ $t("Atualizar") }}
          <i class="mdi mdi-check"/>
        </button>
      </section>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: ["item", "atualizarMotivoReagendamento"],
}
</script>
